import React from 'react';
import './Education.css';

const Education = () => {
  const educationData = [
    {
      degree: "PhD in Economics",
      institution: "Bhimrao Ambedkar University, Agra",
      year: "2011",
      score: "",
      description: "Research on rural credit systems for agricultural development"
    },
    {
      degree: "MBS (International Business)",
      institution: "IICMR, Pune University",
      year: "2014",
      score: "First Class",
      specialization: "International Buisness Management"
    },
    {
      degree: "PGDBM",
      institution: "IICMR, Pune University",
      year: "2013",
      score: "First Class",
      specialization: "Financial Management"
    },
    {
      degree: "MA Economics",
      institution: "Bhimrao Ambedkar University, Agra",
      year: "2002",
      score: "First Class",
      specialization: "Development Economics"
    }
  ];

  return (
    <section id="education" className="education-section">
      <div className="container">
        <div className="section-header">
          <h2>Education</h2>
          <p>Academic qualifications and achievements</p>
        </div>

        <div className="education-list">
          {educationData.map((edu, index) => (
            <div key={index} className="education-item">
              <div className="item-main">
                <h3>{edu.degree}</h3>
                <span className="year">{edu.year}</span>
              </div>
              <p className="institution">{edu.institution}</p>
              {edu.score && <span className="score">{edu.score}</span>}
              {edu.specialization && (
                <div className="specialization">{edu.specialization}</div>
              )}
              {edu.description && (
                <div className="description">{edu.description}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
